import type { StockImportResult, StockImportRow } from '@/types'

/** Rows to show in the preview grid: problems first, then the rest, capped. */
export function previewRows(rows: StockImportRow[], cap = 300): { shown: StockImportRow[]; hidden: number } {
  const bad = rows.filter((r) => r.errors.length > 0)
  const good = rows.filter((r) => r.errors.length === 0)
  const ordered = [...bad, ...good]
  return { shown: ordered.slice(0, cap), hidden: Math.max(0, ordered.length - cap) }
}

/** A commit is offered only for a clean preview with something in it. */
export function canCommitImport(result: StockImportResult | null | undefined): boolean {
  return Boolean(result && result.dry_run && result.error_rows === 0 && result.valid_rows > 0)
}

/** "8964000123456, 8964000123463 ×24" for the preview grid. */
export function describeBarcodes(codes: StockImportRow['barcodes']): string {
  return codes.map((c) => (c.pack_qty === 1 ? c.barcode : `${c.barcode} ×${c.pack_qty}`)).join(', ')
}

/** The Expiry cell of the preview: '' for an item that is not tracked and
 *  carries no date, otherwise what will be saved ("Tracked · 5-day shelf
 *  life · opening stock expires 2026-10-04"). */
export function describeImportExpiry(r: Pick<StockImportRow, 'tracks_expiry' | 'shelf_life_days' | 'opening_expiry'>): string {
  const parts: string[] = []
  if (r.tracks_expiry) parts.push('Tracked')
  if (r.shelf_life_days) parts.push(`${r.shelf_life_days}-day shelf life`)
  if (r.opening_expiry) parts.push(`opening stock expires ${r.opening_expiry}`)
  return parts.join(' · ')
}

/** Strips the data-URL prefix FileReader puts in front of base64 content. */
export function dataUrlToBase64(dataUrl: string): string {
  const comma = dataUrl.indexOf(',')
  return comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl
}
